// import React, {
//   useRef,
//   useEffect,
//   useState,
//   useCallback,
//   useMemo,
// } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { _Api, _PdfApi } from "../../api/_call";
// import {
//   success,
//   error,
//   loading,
//   Updateloading,
// } from "../../common/helpers/toastify";
// import TableColumnModal from "../../common/modules/tableColumn";
// import ConfirmationModel from "../../common/modules/confirmationmodel";
// import Advancedfiltermodel from "../../common/modules/advanced-filter-model";
// import { transactionPurchasetablehead } from "../../common/Tablehead";
// import { useSelector } from "react-redux";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   purchase_status,
//   status_priority,
// } from "../../common/helpers/status_class";
// import Select, { components } from "react-select";
// import {
//   toFormatPrice,
//   toUnformatPrice,
//   transactionTotals,
//   buildTodayDateRange,
//   buildLastMonthDateRange,
//   buildStatusDateMapFromState,
// } from "../../common/helpers/function";
// import { purchase_product_list } from "../../transaction/subTables/purchase/purchasesubtable";
// import ProductImageSliderModal from "../../common/modules/productImageslider";
// import ProductModal from "../../common/modules/ProductModal";
// import SocialModal from "../../common/modules/SocialModal/SocialModal";
// import { Pagination } from "../../common/Pagination";
// import { useTranslation } from "react-i18next";
// import * as FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import { formatDate } from "../../common/helpers/formatDate";
// import TableLoader from "../../../admin/common/TableLoader";
// import GreenTick from "../../../admin/common/icons/GreenTick";

// // Column order mirrors transactionPurchasetablehead — index-aligned so a
// // column's sort key / visibility can be looked up by its position.
// const SORT_KEYS = [
//   "date",
//   "pu_no",
//   "po_no",
//   "supplier",
//   "ship_to",
//   "sku",
//   "qty",
//   "delivery_date",
//   "due_days",
//   "amount",
//   "status",
//   "priority",
//   null,
//   null,
//   null,
//   null,
// ];
// const SORT_ACCESSORS = {
//   date: (r) => r?.transaction_date_unformated || r?.createdAt,
//   pu_no: (r) => r?.pu_no,
//   po_no: (r) => r?.po_no,
//   supplier: (r) => r?.supplier_name,
//   ship_to: (r) => r?.location_name,
//   sku: (r) => Number(r?.sku) || 0,
//   qty: (r) => Number(r?.total_quantity) || 0,
//   delivery_date: (r) => r?.delivery_date_unformated || r?.delivery_date,
//   due_days: (r) => Number(r?.due_days) || 0,
//   amount: (r) => toUnformatPrice(r?.total_amount),
//   status: (r) => r?.status?.pu_status,
//   priority: (r) => r?.status?.priority,
// };

// const TransactionPurchase = (props) => {
//   const { t } = useTranslation();
//   let navigate = useNavigate();
//   const dataFetched = useRef();
//   const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
//   const totalcountsnumber = useSelector((state) => state.app.totalcountsnumber);
//   const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
//   const [datefilter, setDatefilter] = useState([]);
//   const [newcolumndata, setnewcolumndata] = useState(
//     transactionPurchasetablehead,
//   );
//   const [limit, setLimit] = useState(100);
//   const [filtername, setFiltername] = useState("");
//   const [transpurchaselist, setTranspurchaselist] = useState([]);
//   const [statement, setStatement] = useState("");
//   const [po_sataus, setPo_sataus] = useState([]);
//   const [po_priority, setpo_priority] = useState([]);
//   const [imageid, setImageid] = useState();
//   const [Productmodaldata, setProductmodaldata] = useState([]);
//   const [selectedLabel, setSelectedLabel] = useState("Pending for Stock");
//   const [skip, setSkip] = useState();
//   const fileType =
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
//   const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
//   const [datalodaer, setDatsLodaer] = useState(false);
//   const [pdfLoadingIds, setPdfLoadingIds] = useState(new Set());
//   const [filterchangestatus, setfilterchangestatus] = useState(2);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const handleSort = (key) => {
//     setSortConfig((prev) =>
//       prev.key === key
//         ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
//         : { key, direction: "asc" },
//     );
//   };
//   const [showSubtasks, setShowSubtasks] = useState(false);
//   const [activeSubtask, setActiveSubtask] = useState("Collapse all");
//   const subtaskRef = useRef(null);
//   const datePickerRef = useRef(null);
//   const statusDateSyncRef = useRef(true);
//   const [datelable, setDatelable] = useState("LastMonth");

//   const [statusDates, setStatusDates] = useState(() => {
//     const lastMonth = buildLastMonthDateRange();
//     const today = buildTodayDateRange();
//     return {
//       outstanding: lastMonth,
//       pending: lastMonth,
//       approved: lastMonth,
//       cancelled: today,
//     };
//   });

//   const statusValueToCountKey = {
//     3: "outstanding",
//     2: "pending",
//     1: "approved",
//     0: "cancelled",
//   };

//   const getStatusCountKey = (statusValue = filterchangestatus) =>
//     statusValueToCountKey[statusValue] || "pending";

//   const applyStatusDateToUi = (statusKey) => {
//     const next = statusDates[statusKey] || buildLastMonthDateRange();
//     const nextStart = next.filter?.[0];
//     const nextEnd = next.filter?.[1];
//     const sameRange = Boolean(
//       datefilter[0] &&
//       datefilter[1] &&
//       nextStart &&
//       nextEnd &&
//       new Date(datefilter[0]).getTime() === new Date(nextStart).getTime() &&
//       new Date(datefilter[1]).getTime() === new Date(nextEnd).getTime(),
//     );
//     if (sameRange) {
//       if (datelable !== next.label) setDatelable(next.label);
//       return false;
//     }
//     setDatefilter([new Date(nextStart), new Date(nextEnd)]);
//     setDatelable(next.label);
//     return true;
//   };

//   const updateCurrentStatusDate = (filter, label) => {
//     const statusKey = getStatusCountKey();
//     setStatusDates((prev) => ({
//       ...prev,
//       [statusKey]: { filter, label },
//     }));
//     setDatefilter(filter);
//     setDatelable(label);
//   };
//   // const colorStyles = {
//   //   option: (styles, { data }) => {
//   //     return {
//   //       ...styles,
//   //       backgroundColor: data.color
//   //     };
//   //   }
//   // };
//   const colorStyles = {
//     option: (styles, { data }) => ({
//       ...styles,
//       backgroundColor: data.color,
//       color: "#fff",
//       fontSize: "16px",
//       padding: "12px 16px",
//       fontFamily: "inherit",
//       cursor: "pointer",
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 9999,
//     }),
//     control: (base) => ({
//       ...base,
//       fontSize: "14px",
//       fontFamily: "inherit",
//       minHeight: "40px",
//     }),
//     menu: (base) => ({
//       ...base,
//       backgroundColor: "#fff",
//       borderRadius: "8px",
//       boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
//       marginTop: "8px",
//       padding: "6px 12px",
//       position: "relative",
//     }),
//   };
//   const CustomMenu = (props) => (
//     <components.Menu {...props}>
//       {/* Arrow */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-10px",
//           left: "calc(100% - 75px)", // position arrow near the left edge of the select box
//           width: 0,
//           height: 0,
//           borderLeft: "12px solid transparent",
//           borderRight: "12px solid transparent",
//           borderBottom: "16px solid #fff",
//           // boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
//         }}
//       />
//       {props.children}
//     </components.Menu>
//   );
//   const priorityarray = [
//     { label: "low", value: 0, color: "#D9D9D9", class: "low-text" },
//     { label: "medium", value: 1, color: "#D2E4FF", class: "medium-text" },
//     { label: "high", value: 2, color: "#FFD2D9", class: "high-text" },
//   ];
//   useEffect(() => {
//     callcolumns();
//   }, []);

//   const callcolumns = async () => {
//     try {
//       const postdata = {
//         name: "tbl_transcation_purchase",
//       };
//       let columnhead = await _Api(
//         postdata,
//         `api/v1/Inventory/common/getColumnHeads`,
//       );
//       if (columnhead.code === 200) {
//         setnewcolumndata(columnhead?.data?.data);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const [state, setstate] = useState({
//     totalPages: 20,
//     currentPage: 1,
//   });

//   const { totalPages, currentPage } = state;
//   const handlePaginations = (current) => {
//     setstate({ ...state, currentPage: current });
//     Gettranscationpurchase(current, "", "");
//   };
//   const filter_status = [
//     {
//       label: t("PO Outstanding"),
//       labelcount: "outstanding",
//       value: 3,
//       color: "gray-mid",
//     },
//     {
//       label: t("Pending for Stock"),
//       labelcount: "pending",
//       value: 2,
//       color: "yellow",
//     },
//     {
//       label: t("Approved"),
//       labelcount: "approved",
//       value: 1,
//       color: "main-green",
//     },
//     {
//       label: t("Canceled"),
//       labelcount: "cancelled",
//       value: 0,
//       color: "danger",
//     },
//   ];
//   // Maps the status-filter bar's color names to real CSS colors, so the
//   // active top-level tab's underline matches whichever status is selected.
//   const STATUS_COLOR_HEX = {
//     yellow: "#F9BC44",
//     "main-green": "#5CC7C1",
//     danger: "#FF5757",
//     "gray-mid": "#A4A4A4",
//   };
//   const activeTabUnderlineColor =
//     STATUS_COLOR_HEX[
//       filter_status.find((f) => f.value === filterchangestatus)?.color
//     ] || "#5CC7C1";
//   const filterbyname = (search) => {
//     setstate({ ...state, currentPage: 1 });
//     Gettranscationpurchase(currentPage, limit, filterchangestatus, search);
//   };
//   const getlimit = (limit) => {
//     setLimit(limit);
//     Gettranscationpurchase(1, limit);
//     setstate({ ...state, currentPage: 1 });
//   };

//   const selectOptions = [
//     { label: 100, value: 100 },
//     { label: 200, value: 200 },
//     { label: 300, value: 300 },
//   ];

//   const setSubTable = async (id) => {
//     var e = document.querySelector("#table-btn_" + id);
//     var classList_ = e.classList;
//     if (classList_.contains("rotate-90")) {
//       classList_.remove("rotate-90");
//       let alllist_data = [...transpurchaselist];
//       alllist_data
//         .filter((item) => item.id === id)
//         .forEach((result) => {
//           result.subTabledata = null;
//         });
//       setTranspurchaselist(alllist_data);
//     } else {
//       classList_.add("rotate-90");
//       let alllist_data = [...transpurchaselist];
//       const postdata = {
//         po_order_id: id,
//         show_all: false,
//         filterchangestatus: filterchangestatus,
//       };
//       let prioritydata = await _Api(
//         postdata,
//         `api/v1/Inventory/purchase/getPuDetails`,
//       );
//       var html_ = purchase_product_list(
//         prioritydata,
//         setImageid,
//         setProductmodaldata,
//         t,
//       );
//       alllist_data
//         .filter((item) => item.id === id)
//         .forEach((result) => {
//           result.subTabledata = html_;
//         });
//       setTranspurchaselist(alllist_data);
//     }
//   };
//   const handleOpenPDF = async (id) => {
//     if (pdfLoadingIds.has(id)) return;
//     setPdfLoadingIds((prev) => new Set(prev).add(id));
//     let GetloadingID = loading();
//     try {
//       const blobData = await _PdfApi(
//         { id },
//         "api/v1/Inventory/purchase/generatePurchasePdf",
//       );
//       const blob = new Blob([blobData], { type: "application/pdf" });
//       const blobUrl = URL.createObjectURL(blob);
//       window.open(blobUrl, "_blank");
//       Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
//     } catch (err) {
//       // console.error("Error opening PDF:", err);
//       // error(t("Something Went Wrong!!"));
//       Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
//     } finally {
//       setPdfLoadingIds((prev) => {
//         const next = new Set(prev);
//         next.delete(id);
//         return next;
//       });
//     }
//   };
//   const setSubTablePU = async (id) => {
//     var e = document.querySelector("#table-btnpu_" + id);
//     var classList_ = e.classList;
//     if (classList_.contains("rotate-90")) {
//       classList_.remove("rotate-90");
//       let alllist_data = [...transpurchaselist];
//       alllist_data
//         .filter((item) => item.id === id)
//         .forEach((result) => {
//           result.subTabledata = null;
//         });
//       setTranspurchaselist(alllist_data);
//     } else {
//       classList_.add("rotate-90");
//       let alllist_data = [...transpurchaselist];
//       const postdata = {
//         po_order_id: id,
//         show_all: false,
//       };
//       let prioritydata = await _Api(
//         postdata,
//         `api/v1/Inventory/purchase/getPuDetails`,
//       );
//       var html_ = purchase_product_list(
//         prioritydata,
//         setImageid,
//         setProductmodaldata,
//         t,
//       );
//       alllist_data
//         .filter((item) => item.id === id)
//         .forEach((result) => {
//           result.subTabledata = html_;
//         });
//       setTranspurchaselist(alllist_data);
//     }
//   };
//   const Changepriority = (index, value, po_order_id) => {
//     setStatement(t("Change Priority"));
//     setpo_priority([{ index: index, status: value, po_order_id: po_order_id }]);
//     var mainarray = [...transpurchaselist];
//     mainarray[index]["status"] = {
//       ...mainarray[index]["status"],
//       priority: value?.value,
//     };
//     setTranspurchaselist(mainarray);
//     document.querySelector("#status_query_select").click();
//   };
//   const handler_status = async () => {
//     try {
//       if (po_sataus[0].po_order_id) {
//         const postdata = {
//           pu_order_id: po_sataus[0].po_order_id,
//           status: po_sataus[0].status?.value,
//         };
//         let statusdata = await _Api(
//           postdata,
//           `api/v1/Inventory/purchase/editPUStatus`,
//         );
//         if (statusdata?.code === 200) {
//           success(t(statusdata?.message));
//           Gettranscationpurchase();
//         } else {
//           error(t(statusdata?.message));
//         }
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   const handler_priority = async () => {
//     try {
//       const postdata = {
//         pu_order_id: po_priority[0].po_order_id,
//         status: po_priority[0].status?.value,
//       };
//       let prioritydata = await _Api(
//         postdata,
//         `api/v1/Inventory/purchase/editPriorityStatus`,
//       );
//       if (prioritydata?.code === 200) {
//         success(t("Successfully Priority Updated!!"));
//         Gettranscationpurchase();
//       } else {
//         error(t("Something Went Wrong!!"));
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   const select_po_status = (index, value, po_order_id) => {
//     setStatement("Change Status");
//     setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
//     document.querySelector("#status_query_select").click();
//   };

//   const [excuteTable, setexcuteTable] = useState(false);

//   const sortedList = useMemo(() => {
//     const accessor = SORT_ACCESSORS[sortConfig.key];
//     if (!accessor) return transpurchaselist;
//     const sorted = [...transpurchaselist].sort((a, b) => {
//       const av = accessor(a);
//       const bv = accessor(b);
//       if (av === undefined || av === null) return 1;
//       if (bv === undefined || bv === null) return -1;
//       if (typeof av === "number" && typeof bv === "number") return av - bv;
//       return String(av).localeCompare(String(bv), undefined, { numeric: true });
//     });
//     return sortConfig.direction === "asc" ? sorted : sorted.reverse();
//   }, [transpurchaselist, sortConfig]);

//   const Gettranscationpurchase = useCallback(
//     async (current, firstlimit, filters_status, search) => {
//       setexcuteTable(false);
//       // setfilterchangestatus(filters_status)
//       if (filterchangestatus === 3) {
//         navigate("/app/inventory/purchaseOrderOutstanding");
//       }
//       try {
//         setDatsLodaer(true);
//         setTimeout(async function () {
//           const postdata = {
//             start_date: datefilter ? datefilter[0] : "",
//             end_date: datefilter ? datefilter[1] : "",
//             search: search ? search : "",
//             skip: skip === 0 ? skip : current ? (current - 1) * limit : 0,
//             status:
//               filters_status === 0
//                 ? 0
//                 : filters_status
//                   ? filters_status
//                   : filterchangestatus,
//             limit: firstlimit ? firstlimit : limit,
//           };

//           let restranspurchase = await _Api(
//             postdata,
//             `api/v1/Inventory/purchase/getList`,
//           );
//           if (restranspurchase?.code === 200) {
//             setDatsLodaer(false);
//             setexcuteTable(true);
//             setstate({
//               ...state,
//               totalPages: Math.ceil(restranspurchase?.count / postdata.limit),
//               currentPage: current ? current : 1,
//             });
//             setTranspurchaselist(restranspurchase?.data);
//             if (!(current && Number(current) > 1)) {
//               transactionTotals({
//                 start_date: datefilter[0],
//                 end_date: datefilter[1],
//                 statusDateMap: buildStatusDateMapFromState(statusDates),
//                 moduleKey: "PU",
//               });
//             }
//             dataFetched.current = false;
//           } else {
//             setDatsLodaer(false);
//           }
//         }, 100);
//       } catch (err) {
//         console.log(err, "err");
//       }
//     },
//     [datefilter, limit, skip, state, navigate, filterchangestatus, statusDates],
//   );

//   useEffect(() => {
//     if (datefilter[0] && datefilter[1]) {
//       Gettranscationpurchase();
//     }
//     // eslint-disable-next-line
//   }, [datefilter]);

//   const downloadexclsheet = async () => {
//     let header_values = [];
//     let bodyarray = [];
//     transactionPurchasetablehead.map(async (r, k) => {
//       header_values.push(r?.lable);
//     });
//     if (transpurchaselist.length) {
//       transpurchaselist.forEach((result, key) => {
//         bodyarray.push([
//           result?.createdAt,
//           result?.pu_no,
//           result?.po_no,
//           result?.supplier_name,
//           result?.location_name,
//           result?.sku,
//           result?.total_quantity,
//           result?.delivery_date,
//           result?.due_days,
//           result?.total_amount,
//           result.status.pu_status === 0
//             ? "Canceled"
//             : result.status.pu_status === 1
//               ? "Completed"
//               : result.status.pu_status === 2
//                 ? "Pending"
//                 : result.status.pu_status === 3
//                   ? "Approved"
//                   : "",
//           result.status.priority === 0
//             ? "Low"
//             : result.status.priority === 1
//               ? "Medium"
//               : "High",
//           result?.note,
//           result?.user_actions?.created_by_name,
//           result?.user_actions?.updated_by_name,
//         ]);
//       });
//     }
//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet(bodyarray, {
//       origin: "A2",
//       skipHeader: true,
//     });
//     XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: "A1" });
//     XLSX.utils.book_append_sheet(wb, ws, "Records");
//     const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     const data = new Blob([fileContent], { type: fileType });
//     FileSaver.saveAs(data, "purchaselist");
//   };
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (subtaskRef.current && !subtaskRef.current.contains(event.target)) {
//         setShowSubtasks(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     const statusKey = getStatusCountKey(filterchangestatus);
//     const rangeChanged = applyStatusDateToUi(statusKey);
//     if (statusDateSyncRef.current) {
//       statusDateSyncRef.current = false;
//       return;
//     }
//     if (!rangeChanged) {
//       Gettranscationpurchase(1, limit, filterchangestatus);
//     }
//     // eslint-disable-next-line
//   }, [filterchangestatus, selectedLabel]);

//   const changeDates = (lable) => {
//     const MainDate = new Date();
//     if (lable === "Today") {
//       const todayStart = new Date();
//       todayStart.setHours(0, 0, 0, 0);
//       updateCurrentStatusDate([todayStart, new Date()], "Today");
//     } else if (lable === "Yesterday") {
//       const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
//       yesterdayStart.setHours(0, 0, 0, 0);
//       const yesterdayEnd = new Date(yesterdayStart);
//       yesterdayEnd.setHours(23, 59, 59, 999);
//       updateCurrentStatusDate([yesterdayStart, yesterdayEnd], "Yesterday");
//     } else if (lable === "7days") {
//       const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
//       sevendays.setHours(0, 0, 0, 0);
//       const todayEnd = new Date();
//       todayEnd.setHours(23, 59, 59, 999);
//       updateCurrentStatusDate([sevendays, todayEnd], "7days");
//     } else if (lable === "30days") {
//       const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
//       days.setHours(0, 0, 0, 0);
//       const todayEnd = new Date();
//       todayEnd.setHours(23, 59, 59, 999);
//       updateCurrentStatusDate([days, todayEnd], "30days");
//     } else if (lable === "ThisMonth") {
//       const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
//       firstDay.setHours(0, 0, 0, 0);
//       const lastDay = new Date(
//         MainDate.getFullYear(),
//         MainDate.getMonth() + 1,
//         0,
//       );
//       lastDay.setHours(23, 59, 59, 999);
//       updateCurrentStatusDate([firstDay, lastDay], "ThisMonth");
//     } else if (lable === "LastMonth") {
//       const firstDay = new Date(
//         MainDate.getFullYear(),
//         MainDate.getMonth() - 1,
//         1,
//       );
//       firstDay.setHours(0, 0, 0, 0);
//       const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0);
//       lastDay.setHours(23, 59, 59, 999);
//       updateCurrentStatusDate([firstDay, lastDay], "LastMonth");
//     }
//   };

//   const collapseAll = () => {
//     document
//       .querySelectorAll(".sku-col.col-highlight.rotate-90")
//       .forEach((el) => {
//         el.classList.remove("rotate-90");
//       });
//     const updated = transpurchaselist.map((result) => ({
//       ...result,
//       subTabledata: null,
//     }));
//     setTranspurchaselist(updated);
//   };

//   const expandAll = async () => {
//     let alllist_data = [...transpurchaselist];
//     const ids = alllist_data.map((item) => item.id);
//     try {
//       const batchResponse = await _Api(
//         { pu_order_ids: ids, show_all: false, filterchangestatus },
//         `api/v1/Inventory/purchase/getPUDetailsBatch`,
//       );
//       if (batchResponse?.code === 200) {
//         for (let i = 0; i < alllist_data.length; i++) {
//           const result = alllist_data[i];
//           const rowData = batchResponse.data[result.id];
//           if (rowData) {
//             const e = document.querySelector("#table-btn_" + result.id);
//             if (e) e.classList.add("rotate-90");
//             alllist_data[i] = {
//               ...alllist_data[i],
//               subTabledata: purchase_product_list(
//                 {
//                   code: 200,
//                   data: {
//                     id: result.id,
//                     po_product_data: rowData?.po_product_data,
//                   },
//                 },
//                 setImageid,
//                 setProductmodaldata,
//                 t,
//               ),
//             };
//           }
//         }
//         setTranspurchaselist([...alllist_data]);
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };

//   return (
//     <React.Fragment>
//       <div className="main-body" style={{ paddingTop: "0px" }}>
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div
//                 style={{
//                   position: "sticky",
//                   top: "128px",
//                   zIndex: 5,
//                   flexShrink: 0,
//                   background: " #f9f9fb",
//                   width: "100%",
//                   paddingTop: "15px",
//                   opacity: 0.9,
//                 }}
//               >
//                 <h1 className="main-body-heading">{t("Transaction")}</h1>
//                 <div className="main-body-top-tab-bar">
//                   <div
//                     className="main-body-top-tab-bar-left-col nav nav-pills"
//                     role="tablist"
//                   >
//                     <Link
//                       className={
//                         parmissiondatashow?.purchase_order?.View
//                           ? "main-body-top-tab-bar-left-col-a nav-link"
//                           : "d-none"
//                       }
//                       to="/app/inventory"
//                     >
//                       <span className="main-body-top-tab-bar-left-col-a-text">
//                         {t("Purchase Order")}
//                       </span>
//                       <span className="num-tab">
//                         {totalcountsnumber?.PO?.total
//                           ? totalcountsnumber?.PO?.total
//                           : "0"}
//                       </span>
//                     </Link>
//                     <Link
//                       className="main-body-top-tab-bar-left-col-a nav-link active"
//                       to="/app/inventory/transactionPurchase"
//                       style={{
//                         "--tab-underline-color": activeTabUnderlineColor,
//                       }}
//                     >
//                       <span className="main-body-top-tab-bar-left-col-a-text">
//                         {t("Purchase")}
//                       </span>
//                       <span
//                         className="num-tab"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#tPurchase"
//                       >
//                         {totalcountsnumber?.PU?.total
//                           ? totalcountsnumber?.PU?.total
//                           : "0"}
//                       </span>
//                     </Link>
//                     <Link
//                       className={
//                         parmissiondatashow?.inventory_transaction_stock_Receive
//                           ?.View
//                           ? "main-body-top-tab-bar-left-col-a nav-link"
//                           : "d-none"
//                       }
//                       to="/app/inventory/stock_transfer"
//                     >
//                       <span className="main-body-top-tab-bar-left-col-a-text">
//                         {t("Stock Transfer")}
//                       </span>
//                       <span className="num-tab">
//                         {totalcountsnumber?.ST?.total
//                           ? totalcountsnumber?.ST?.total
//                           : "0"}
//                       </span>
//                     </Link>
//                     <Link
//                       className={
//                         parmissiondatashow?.inventory_transaction_stock_Receive
//                           ?.View
//                           ? "main-body-top-tab-bar-left-col-a nav-link"
//                           : "d-none"
//                       }
//                       to="/app/inventory/transactionStockReceive"
//                     >
//                       <span className="main-body-top-tab-bar-left-col-a-text">
//                         {t("Stock Receive")}
//                       </span>
//                       <span className="num-tab">
//                         {totalcountsnumber?.SR ? totalcountsnumber?.SR : "0"}
//                       </span>
//                     </Link>
//                     <Link
//                       className="main-body-top-tab-bar-left-col-a nav-link"
//                       to="/app/inventory/stockAdjustment"
//                     >
//                       <span className="main-body-top-tab-bar-left-col-a-text">
//                         {t("Stock Adjustment")}
//                       </span>
//                       <span className="num-tab">
//                         {totalcountsnumber?.SA?.total
//                           ? totalcountsnumber?.SA?.total
//                           : "0"}
//                       </span>
//                     </Link>
//                   </div>
//                   <div className="main-body-top-tab-bar-right-col">
//                     <Link to="" className="main-body-top-tab-bar-right-col-a">
//                       <img
//                         src={base_assets + "images/icons/kanban-icon.svg"}
//                         alt=""
//                       />
//                       <span className="main-body-top-tab-bar-right-col-a-text">
//                         {t("KANBAN")}
//                       </span>
//                     </Link>
//                     <Link
//                       to="/app/inventory/purchaseOrderOutstanding"
//                       className="main-body-top-tab-bar-right-col-a"
//                     >
//                       <img
//                         src={base_assets + "images/icons/outstanding-icon.png"}
//                         alt=""
//                       />
//                       <span className="main-body-top-tab-bar-right-col-a-text">
//                         {t("PO Outstanding")}
//                       </span>
//                       <span className="main-body-top-tab-bar-right-col-a-num">
//                         {totalcountsnumber?.PU?.outstanding
//                           ? "(" + totalcountsnumber?.PU?.outstanding + ")"
//                           : ""}
//                       </span>
//                     </Link>
//                     <span
//                       className={
//                         parmissiondatashow?.inventory_transaction_purchase?.Add
//                           ? "divider"
//                           : "d-none"
//                       }
//                     />
//                     <Link
//                       to="/app/inventory/createPurchase"
//                       className={
//                         parmissiondatashow?.inventory_transaction_purchase?.Add
//                           ? "main-body-top-tab-bar-right-col-a"
//                           : "d-none"
//                       }
//                     >
//                       <img
//                         src={base_assets + "images/icons/plus-circle-white.png"}
//                         alt=""
//                       />
//                       <span className="main-body-top-tab-bar-right-col-a-text">
//                         {t("Create")}
//                       </span>
//                     </Link>
//                   </div>
//                 </div>
//                 <div id="tPurchase" className="collapse show">
//                   <div className="main-body-top-color-bar">
//                     {filter_status.map((result, key) => {
//                       return (
//                         <div
//                           className="main-body-top-color-bar-single"
//                           onClick={() => {
//                             // Gettranscationpurchase("", '', result?.value);
//                             setfilterchangestatus(result?.value);
//                             setSelectedLabel(result?.label);
//                             setSkip(0);
//                           }}
//                           key={key}
//                         >
//                           <div
//                             className={
//                               "main-body-top-color-bar-single-color " +
//                               result?.color +
//                               "-bg"
//                             }
//                           />
//                           <span
//                             className={
//                               "main-body-top-color-bar-single-color-status " +
//                               result?.color +
//                               "-text"
//                             }
//                           >
//                             {result?.label}
//                           </span>
//                           <span>
//                             {totalcountsnumber?.PU?.[`${result?.labelcount}`]
//                               ? totalcountsnumber?.PU?.[`${result?.labelcount}`]
//                               : "0"}
//                           </span>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//                 <div className="main-body-top-status-bar">
//                   <Select
//                     className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
//                     options={selectOptions}
//                     value={{ label: limit, value: limit }}
//                     onChange={(e) => {
//                       setLimit(e.value);
//                       getlimit(e.value);
//                     }}
//                     isSearchable={false}
//                   />
//                   <div className="main-body-top-status-bar-filter">
//                     <input
//                       type="text"
//                       value={filtername}
//                       className="main-body-top-status-bar-filter-input"
//                       placeholder={t("PU No/StockID")}
//                       onKeyPress={(e) =>
//                         e.key === "Enter" && filterbyname(e.target.value)
//                       }
//                       onChange={(e) => setFiltername(e.target.value)}
//                     />
//                     {filtername ? (
//                       <img
//                         className="main-body-top-status-bar-filter-clear"
//                         src={base_assets + "images/icons/False.png"}
//                         onClick={(e) => {
//                           setFiltername("");
//                           filterbyname("");
//                         }}
//                         alt=""
//                       />
//                     ) : (
//                       ""
//                     )}
//                     <button
//                       onClick={() => filterbyname(filtername)}
//                       className="main-body-top-status-bar-filter-search"
//                     >
//                       <i className="fa fa-search" aria-hidden="true" />
//                     </button>
//                     <Advancedfiltermodel></Advancedfiltermodel>
//                   </div>
//                   <div className="main-body-top-status-bar-multi-date-picker">
//                     <button className="print-export-dropdown-selected-icon d-none">
//                       <img
//                         src={base_url_assets + "images/icons/printer-icon.png"}
//                         alt=""
//                       />
//                     </button>
//                     <div className="position-relative" ref={subtaskRef}>
//                       <div
//                         className={`calendarlist-headbar-left-subtasks ${activeSubtask === "Expand all" ? "active" : ""}`}
//                         onClick={() => setShowSubtasks(!showSubtasks)}
//                         style={{ border: "none", background: "none" }}
//                       >
//                         <svg
//                           width="24"
//                           height="24"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z"
//                             stroke={
//                               activeSubtask === "Expand all"
//                                 ? "#52CBC4"
//                                 : "#A0A0A0"
//                             }
//                           />
//                           <path
//                             d="M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z"
//                             stroke={
//                               activeSubtask === "Expand all"
//                                 ? "#52CBC4"
//                                 : "#A0A0A0"
//                             }
//                           />
//                           <path
//                             d="M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3Z"
//                             stroke={
//                               activeSubtask === "Expand all"
//                                 ? "#52CBC4"
//                                 : "#A0A0A0"
//                             }
//                           />
//                           <path
//                             d="M5 8V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14"
//                             stroke={
//                               activeSubtask === "Expand all"
//                                 ? "#52CBC4"
//                                 : "#A0A0A0"
//                             }
//                           />
//                           <path
//                             d="M5 7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H14"
//                             stroke={
//                               activeSubtask === "Expand all"
//                                 ? "#52CBC4"
//                                 : "#A0A0A0"
//                             }
//                           />
//                         </svg>
//                         <span>{t("Subtasks")}</span>
//                       </div>
//                       {showSubtasks && (
//                         <div className="calendarlist-headbar-left-subtaskdropdown">
//                           <div className="calendarlist-headbar-left-subtaskdropdown-inner">
//                             <div className="calendarlist-headbar-left-subtaskdropdown-inner-title">
//                               {t("Show Subtasks")}
//                             </div>
//                             <div className="calendarlist-headbar-left-subtaskdropdown-inner-list">
//                               <div
//                                 className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
//                                 onClick={() => {
//                                   setActiveSubtask("Collapse all");
//                                   setShowSubtasks(false);
//                                   collapseAll();
//                                 }}
//                               >
//                                 <div className="heading">
//                                   {t("Collapse all")}
//                                   <span className="default">
//                                     {t("(default)")}
//                                   </span>
//                                 </div>
//                                 {activeSubtask === "Collapse all" && (
//                                   <div>
//                                     <GreenTick />
//                                   </div>
//                                 )}
//                               </div>
//                               <div
//                                 className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
//                                 onClick={() => {
//                                   setActiveSubtask("Expand all");
//                                   setShowSubtasks(false);
//                                   expandAll();
//                                 }}
//                               >
//                                 <div>{t("Expand all")}</div>
//                                 {activeSubtask === "Expand all" && (
//                                   <div>
//                                     <GreenTick />
//                                   </div>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                     <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
//                       <button
//                         className="dropdown-toggle btn-style align-items-center d-flex"
//                         type="button"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         <svg
//                           width="16"
//                           height="16"
//                           viewBox="0 0 16 16"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
//                             stroke="currentcolor"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                         {t(datelable)}
//                       </button>
//                       <ul
//                         className="dropdown-menu dropdown-menu-right-fix"
//                         aria-labelledby="dropdownMenuButton1"
//                       >
//                         <li
//                           className={`dropdown-item ${datelable === "Today" ? "active" : ""}`}
//                           onClick={() => changeDates("Today")}
//                         >
//                           {t("Today")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`}
//                           onClick={() => changeDates("Yesterday")}
//                         >
//                           {t("Yesterday")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "7days" ? "active" : ""}`}
//                           onClick={() => changeDates("7days")}
//                         >
//                           {t("Last 7 days")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "30days" ? "active" : ""}`}
//                           onClick={() => changeDates("30days")}
//                         >
//                           {t("Last 30 days")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`}
//                           onClick={() => changeDates("ThisMonth")}
//                         >
//                           {t("This Month")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`}
//                           onClick={() => changeDates("LastMonth")}
//                         >
//                           {t("Last Month")}
//                         </li>
//                         <li
//                           className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`}
//                           onClick={() => datePickerRef.current.setOpen(true)}
//                         >
//                           {t("Custom Range")}
//                         </li>
//                       </ul>
//                       <DatePicker
//                         selectsRange={true}
//                         monthsShown={2}
//                         startDate={datefilter[0]}
//                         endDate={datefilter[1]}
//                         onChange={(update) => {
//                           const startDate = update[0];
//                           const endDate = update[1];
//                           setDatelable("Custom Range");
//                           if (startDate && endDate) {
//                             const modifiedStartDate = new Date(startDate);
//                             modifiedStartDate.setHours(0, 0, 0, 0);
//                             const modifiedEndDate = new Date(endDate);
//                             modifiedEndDate.setHours(23, 59, 59, 999);
//                             updateCurrentStatusDate(
//                               [modifiedStartDate, modifiedEndDate],
//                               "Custom Range",
//                             );
//                           } else {
//                             setDatefilter([startDate, endDate]);
//                           }
//                         }}
//                         dateFormat="yyyy-MM-dd"
//                         ref={datePickerRef}
//                         autoComplete="none"
//                       />
//                     </div>
//                     <div className="main-body-top-status-bar-print-export-dropdown dropdown">
//                       <button
//                         className="btn dropdown-toggle"
//                         type="button"
//                         id="dropdownMenuButton1"
//                         data-bs-toggle="dropdown"
//                         aria-expanded="false"
//                       >
//                         <img
//                           src={
//                             base_url_assets +
//                             "images/icons/ellipsis-circular.png"
//                           }
//                           alt=""
//                         />
//                       </button>
//                       <ul
//                         className="dropdown-menu"
//                         aria-labelledby="dropdownMenuButton1"
//                       >
//                         <li
//                           className="dropdown-item"
//                           onClick={() => downloadexclsheet()}
//                         >
//                           <div className="dropdown-item-img">
//                             <img
//                               src={
//                                 base_url_assets +
//                                 "images/icons/export-x-icon.png"
//                               }
//                               alt=""
//                             />
//                           </div>
//                           <span>{t("export")}</span>
//                         </li>
//                         <li
//                           className="dropdown-item"
//                           data-bs-toggle="modal"
//                           data-bs-target="#columnModal"
//                         >
//                           <div className="dropdown-item-img">
//                             <img
//                               src={
//                                 base_url_assets + "images/icons/column-icon.png"
//                               }
//                               alt=""
//                             />
//                           </div>
//                           <span>{t("column")}</span>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div
//                 className="main-body-main-table-wrap position-relative"
//                 id="table-scroll"
//                 style={{ maxWidth: "100%", overflowX: "auto" }}
//               >
//                 <table
//                   id="tbl_transactionPurchase_list"
//                   className="stripe row-border order-column common-table table-striped main-table w-100"
//                 >
//                   <thead>
//                     <tr>
//                       {newcolumndata?.map((col, index) => {
//                         if (!col?.status) return null;
//                         const sortKey = SORT_KEYS[index];
//                         const active = sortConfig.key === sortKey;
//                         return (
//                           <th
//                             key={index}
//                             className={col.class}
//                             onClick={
//                               sortKey ? () => handleSort(sortKey) : undefined
//                             }
//                             style={sortKey ? { cursor: "pointer" } : undefined}
//                           >
//                             {t(col.lable)}
//                             {sortKey ? (
//                               <div className="up-down-arrow-btn">
//                                 <img
//                                   className={
//                                     "up-down-arrow-img up-down-arrow-img-forward" +
//                                     (active && sortConfig.direction === "desc"
//                                       ? ""
//                                       : " active")
//                                   }
//                                   src={
//                                     base_url_assets +
//                                     "images/icons/up-down-arrow.png"
//                                   }
//                                   alt=""
//                                 />
//                                 <img
//                                   className={
//                                     "up-down-arrow-img up-down-arrow-img-reverse" +
//                                     (active && sortConfig.direction === "desc"
//                                       ? " active"
//                                       : "")
//                                   }
//                                   src={
//                                     base_url_assets +
//                                     "images/icons/up-down-arrow-reverse.png"
//                                   }
//                                   alt=""
//                                 />
//                               </div>
//                             ) : null}
//                           </th>
//                         );
//                       })}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <>
//                       {sortedList.length
//                         ? sortedList.map((result, key) => {
//                             var po_status_class_val = purchase_status(
//                               result.status.pu_status,
//                             );
//                             var priority_class_val = status_priority(
//                               result.status.priority,
//                             );
//                             var valueofpriority = [];
//                             if (result.status.priority === 0) {
//                               valueofpriority = [
//                                 { label: t("Low"), value: 0, color: "#D9D9D9" },
//                               ];
//                             } else if (result.status.priority === 1) {
//                               valueofpriority = [
//                                 {
//                                   label: t("Medium"),
//                                   value: 1,
//                                   color: "#D2E4FF",
//                                 },
//                               ];
//                             } else {
//                               valueofpriority = [
//                                 {
//                                   label: t("High"),
//                                   value: 2,
//                                   color: "#FFD2D9",
//                                 },
//                               ];
//                             }
//                             var colorsArray = [];
//                             var valueofstatus = [];
//                             if (result.status.pu_status === 1) {
//                               valueofstatus = [
//                                 {
//                                   label: t("Approved"),
//                                   value: result.status.pu_status,
//                                   color: "#0ECB81",
//                                 },
//                               ];
//                               colorsArray = [
//                                 {
//                                   label: "Pending",
//                                   value: 2,
//                                   color: "#F9BC44",
//                                 },
//                               ];
//                             } else if (result.status.pu_status === 2) {
//                               valueofstatus = [
//                                 {
//                                   label: t("Pending"),
//                                   value: result.status.pu_status,
//                                   color: "#F9BC44",
//                                 },
//                               ];
//                               colorsArray = [
//                                 {
//                                   label: t("Approved"),
//                                   value: 1,
//                                   color: "#0ECB81",
//                                 },
//                                 {
//                                   label: t("Canceled"),
//                                   value: 0,
//                                   color: "#FF5757",
//                                 },
//                               ];
//                             } else if (result.status.pu_status === 0) {
//                               valueofstatus = [
//                                 {
//                                   label: t("Canceled"),
//                                   value: result.status.pu_status,
//                                   color: "#FF5757",
//                                 },
//                               ];
//                             } else if (result.status.pu_status === 3) {
//                               valueofstatus = [
//                                 {
//                                   label: t("Completed"),
//                                   value: result.status.pu_status,
//                                   color: "#68B8F2",
//                                 },
//                               ];
//                             }
//                             return (
//                               <React.Fragment key={key + "po_product_editList"}>
//                                 <tr
//                                   id={`common-main-table-wrap-${result?.id}`}
//                                   key={result?.id}
//                                 >
//                                   {newcolumndata[0]?.status && (
//                                     <td className="fixed-side">
//                                       {result?.createdAt
//                                         ? result?.createdAt
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[1]?.status && (
//                                     <td className="po-no">
//                                       <Link
//                                         to={
//                                           result?.pu_no
//                                             ? "/app/inventory/editPurchase"
//                                             : ""
//                                         }
//                                         state={{
//                                           product_id: result.id,
//                                           location_id: result?.location_id,
//                                           supplier_id: result?.supplier_id,
//                                           warehouse_id: result?.warehouse_id,
//                                           pu_no: result?.pu_no,
//                                           Voucher_id: result?.voucher_id,
//                                           transactiondate:
//                                             result?.transaction_date_unformated,
//                                           deliverydate:
//                                             result?.delivery_date_unformated,
//                                           purchasestatus:
//                                             result.status.pu_status,
//                                           printparmission:
//                                             parmissiondatashow
//                                               ?.inventory_transaction_purchase
//                                               ?.Print,
//                                         }}
//                                       >
//                                         {result?.pu_no ? result?.pu_no : "-"}
//                                       </Link>
//                                     </td>
//                                   )}
//                                   {newcolumndata[2]?.status &&
//                                     (result?.po_order_count > 1 ? (
//                                       <td
//                                         className="sku-col"
//                                         onClick={() => setSubTablePU(result.id)}
//                                         id={"table-btnpu_" + result.id}
//                                       >
//                                         <img
//                                           className="sku-col-arrow"
//                                           src={
//                                             base_assets +
//                                             "/images/icons/right_green_button.png"
//                                           }
//                                           alt=""
//                                         />
//                                         <span>{result?.po_order_count}</span>
//                                       </td>
//                                     ) : (
//                                       <td className="po-no">
//                                         <Link
//                                           to={
//                                             result?.po_no
//                                               ? "/app/inventory/edit-po-pos"
//                                               : ""
//                                           }
//                                           state={{
//                                             posid: result?.po_order_id,
//                                             po_status: 1,
//                                             transactiondate:
//                                               result?.transaction_date_unformated,
//                                             deliverydate:
//                                               result?.delivery_date_unformated,
//                                           }}
//                                         >
//                                           {result?.po_no ? result?.po_no : "-"}
//                                         </Link>
//                                       </td>
//                                     ))}
//                                   {newcolumndata[3]?.status && (
//                                     <td>
//                                       {result?.supplier_name
//                                         ? result?.supplier_name
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[4]?.status && (
//                                     <td>
//                                       {result?.location_name
//                                         ? result?.location_name
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[5]?.status && (
//                                     <td
//                                       className="sku-col col-highlight"
//                                       onClick={() => setSubTable(result.id)}
//                                       id={"table-btn_" + result.id}
//                                     >
//                                       <div className="td-icons-wrap">
//                                         <div>
//                                           <img
//                                             className="sku-col-arrow"
//                                             src={
//                                               base_assets +
//                                               "/images/icons/right_green_button.png"
//                                             }
//                                             alt=""
//                                           />
//                                           <span>
//                                             {result?.sku ? result?.sku : "-"}
//                                           </span>
//                                         </div>
//                                         {result.allocatable ? (
//                                           <div className="td-icons-wrap-link">
//                                             <img
//                                               className="img "
//                                               src={
//                                                 base_assets +
//                                                 "images/icons/link-icon.svg"
//                                               }
//                                               alt=""
//                                             />
//                                           </div>
//                                         ) : (
//                                           ""
//                                         )}
//                                         <div className="tooltip-area-up">
//                                           {result?.pos_Qty !== 0 ? (
//                                             <div className="td-icons-wrap-user">
//                                               <img
//                                                 className="img"
//                                                 src={
//                                                   base_assets +
//                                                   "images/icons/gray-user.png"
//                                                 }
//                                                 alt=""
//                                               />{" "}
//                                               <span>{result?.pos_Qty}</span>
//                                             </div>
//                                           ) : (
//                                             ""
//                                           )}
//                                           <span className="tooltip-area-up-text">
//                                             {result?.pos?.customer_name}
//                                             {result?.pos?.customer_name ? (
//                                               <br />
//                                             ) : (
//                                               ""
//                                             )}
//                                             {result?.pos?.ref}
//                                             <br />
//                                             {formatDate(
//                                               result?.pos?.delivery_date,
//                                             )}
//                                           </span>
//                                         </div>
//                                       </div>
//                                     </td>
//                                   )}
//                                   {newcolumndata[6]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.total_quantity
//                                         ? result?.total_quantity
//                                         : "0"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[7]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.delivery_date
//                                         ? result?.delivery_date
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[8]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.due_days}
//                                     </td>
//                                   )}
//                                   {newcolumndata[9]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.total_amount
//                                         ? toFormatPrice(result?.total_amount, {
//                                             addSymbol: true,
//                                           })
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[10]?.status && (
//                                     <td className="col-highlight">
//                                       <div
//                                         className={
//                                           "dropdown status-dropdown status-dropdown-select " +
//                                           po_status_class_val
//                                         }
//                                       >
//                                         <Select
//                                           options={
//                                             parmissiondatashow
//                                               ?.inventory_transaction_purchase
//                                               ?.Status
//                                               ? colorsArray
//                                               : []
//                                           }
//                                           value={valueofstatus}
//                                           isDisabled={
//                                             result.status.pu_status === 0
//                                               ? true
//                                               : false
//                                           }
//                                           onChange={(event) =>
//                                             select_po_status(
//                                               key,
//                                               event,
//                                               result.id,
//                                             )
//                                           }
//                                           classNamePrefix="status-dropdown-select"
//                                           styles={colorStyles}
//                                           getOptionLabel={(e) => (
//                                             <div className="">{e.label}</div>
//                                           )}
//                                           isSearchable={false}
//                                           menuPortalTarget={document.body}
//                                           menuPosition="fixed"
//                                           components={{ Menu: CustomMenu }}
//                                         />
//                                       </div>
//                                     </td>
//                                   )}
//                                   {newcolumndata[11]?.status && (
//                                     <td className="col-highlight">
//                                       <div
//                                         className={
//                                           "dropdown status-dropdown status-dropdown-select " +
//                                           priority_class_val
//                                         }
//                                       >
//                                         <Select
//                                           options={priorityarray}
//                                           value={valueofpriority}
//                                           onChange={(event) =>
//                                             Changepriority(
//                                               key,
//                                               event,
//                                               result.id,
//                                             )
//                                           }
//                                           classNamePrefix="status-dropdown-select"
//                                           styles={colorStyles}
//                                           getOptionLabel={(e) => (
//                                             <div className={e.class}>
//                                               {e.label}
//                                             </div>
//                                           )}
//                                           isSearchable={false}
//                                           menuPortalTarget={document.body}
//                                           menuPosition="fixed"
//                                           components={{ Menu: CustomMenu }}
//                                         />
//                                       </div>
//                                     </td>
//                                   )}
//                                   {newcolumndata[12]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.note ? result?.note : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[13]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.user_actions?.created_by_name
//                                         ? result?.user_actions?.created_by_name
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[14]?.status && (
//                                     <td className="col-highlight">
//                                       {result?.user_actions?.updated_by_name
//                                         ? result?.user_actions?.updated_by_name
//                                         : "-"}
//                                     </td>
//                                   )}
//                                   {newcolumndata[15]?.status && (
//                                     <td>
//                                       <div
//                                         onClick={() =>
//                                           !pdfLoadingIds.has(result?.id) &&
//                                           handleOpenPDF(result?.id)
//                                         }
//                                         style={{
//                                           opacity: pdfLoadingIds.has(result?.id)
//                                             ? 0.5
//                                             : 1,
//                                           pointerEvents: pdfLoadingIds.has(
//                                             result?.id,
//                                           )
//                                             ? "none"
//                                             : "auto",
//                                         }}
//                                       >
//                                         <img
//                                           className="pdf-image cursor-pointer"
//                                           src={
//                                             base_assets +
//                                             "images/icons/pdf-icon.png"
//                                           }
//                                           alt="PDF"
//                                         />
//                                       </div>
//                                     </td>
//                                   )}
//                                 </tr>
//                                 {excuteTable ? (
//                                   <>
//                                     {typeof result.subTabledata == "undefined"
//                                       ? (result.subTabledata = "")
//                                       : result.subTabledata}
//                                   </>
//                                 ) : null}
//                               </React.Fragment>
//                             );
//                           })
//                         : ""}
//                     </>
//                   </tbody>
//                   <tfoot>
//                     <tr>
//                       {newcolumndata[0]?.status && <td />}
//                       {newcolumndata[1]?.status && <td />}
//                       {newcolumndata[2]?.status && <td />}
//                       {newcolumndata[3]?.status && <td />}
//                       {newcolumndata[4]?.status && <td />}
//                       {newcolumndata[5]?.status && <td />}
//                       {newcolumndata[6]?.status && (
//                         <td>
//                           {transpurchaselist
//                             ? transpurchaselist?.reduce(
//                                 (interation, val) =>
//                                   (interation =
//                                     interation + parseInt(val.total_quantity)),
//                                 0,
//                               )
//                             : ""}
//                         </td>
//                       )}
//                       {newcolumndata[7]?.status && <td />}
//                       {newcolumndata[8]?.status && <td />}
//                       {newcolumndata[9]?.status && (
//                         <td>
//                           {toFormatPrice(
//                             transpurchaselist
//                               ? transpurchaselist?.reduce(
//                                   (interation, val) =>
//                                     (interation =
//                                       interation +
//                                       toUnformatPrice(val?.total_amount)),
//                                   0,
//                                 )
//                               : "",
//                             { addSymbol: true },
//                           )}
//                         </td>
//                       )}
//                       {newcolumndata[10]?.status && <td />}
//                       {newcolumndata[11]?.status && <td />}
//                       {newcolumndata[12]?.status && <td />}
//                       {newcolumndata[13]?.status && <td />}
//                       {newcolumndata[14]?.status && <td />}
//                       {newcolumndata[15]?.status && <td />}
//                     </tr>
//                   </tfoot>
//                 </table>
//                 {datalodaer && <TableLoader />}
//               </div>
//             </div>
//             {transpurchaselist.length > 0 ? (
//               <Pagination
//                 total={totalPages}
//                 current={currentPage}
//                 pagination={(crPage) => handlePaginations(crPage)}
//               />
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <SocialModal />
//         <ProductModal
//           data_product={Productmodaldata}
//           setOneproduct={setProductmodaldata}
//           editproduct_submit={""}
//         />
//         <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
//         <TableColumnModal
//           tablehead={transactionPurchasetablehead}
//           tblName={"tbl_transcation_purchase"}
//           calldatatable={Gettranscationpurchase}
//           setnewcolumndata={setnewcolumndata}
//         ></TableColumnModal>
//         <ConfirmationModel
//           statement={statement}
//           handler_submit={
//             statement === "Change Status" ? handler_status : handler_priority
//           }
//           handler_dismiss={Gettranscationpurchase}
//         ></ConfirmationModel>
//         <button
//           className="d-none"
//           data-bs-toggle="modal"
//           data-bs-target="#createPurchaseModal"
//           id="status_query_select"
//         ></button>
//       </div>
//     </React.Fragment>
//   );
// };

// export default TransactionPurchase;






import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { _Api, _PdfApi } from "../../api/_call";
import {
  loading,
  Updateloading,
} from "../../common/helpers/toastify";
import TableColumnModal from "../../common/modules/tableColumn";
import ConfirmationModel from "../../common/modules/confirmationmodel";
import Advancedfiltermodel from "../../common/modules/advanced-filter-model";
import { transactionPurchasetablehead } from "../../common/Tablehead";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  purchase_status,
  status_priority,
} from "../../common/helpers/status_class";
import Select, { components } from "react-select";
import {
  toFormatPrice,
  toUnformatPrice,
  transactionTotals,
  buildTodayDateRange,
  buildLastMonthDateRange,
  buildStatusDateMapFromState,
} from "../../common/helpers/function";
import { purchase_product_list } from "../../transaction/subTables/purchase/purchasesubtable";
import ProductImageSliderModal from "../../common/modules/productImageslider";
import ProductModal from "../../common/modules/ProductModal";
import SocialModal from "../../common/modules/SocialModal/SocialModal";
import { Pagination } from "../../common/Pagination";
import { useTranslation } from "react-i18next";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { formatDate } from "../../common/helpers/formatDate";
import TableLoader from "../../../admin/common/TableLoader";
import GreenTick from "../../../admin/common/icons/GreenTick";
import PoPuSampleFormatModal from "../../common/modules/PoPuSampleFormatModal";

// Column order mirrors transactionPurchasetablehead — index-aligned so a
// column's sort key / visibility can be looked up by its position.
const SORT_KEYS = [
  "date",
  "pu_no",
  "po_no",
  "supplier",
  "ship_to",
  "sku",
  "qty",
  "delivery_date",
  "due_days",
  "amount",
  "status",
  "priority",
  null,
  null,
  null,
  null,
];
const SORT_ACCESSORS = {
  date: (r) => r?.transaction_date_unformated || r?.createdAt,
  pu_no: (r) => r?.pu_no,
  po_no: (r) => r?.po_no,
  supplier: (r) => r?.supplier_name,
  ship_to: (r) => r?.location_name,
  sku: (r) => Number(r?.sku) || 0,
  qty: (r) => Number(r?.total_quantity) || 0,
  delivery_date: (r) => r?.delivery_date_unformated || r?.delivery_date,
  due_days: (r) => Number(r?.due_days) || 0,
  amount: (r) => toUnformatPrice(r?.total_amount),
  status: (r) => r?.status?.pu_status,
  priority: (r) => r?.status?.priority,
};

const TransactionPurchase = (props) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const dataFetched = useRef();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const totalcountsnumber = useSelector((state) => state.app.totalcountsnumber);
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [datefilter, setDatefilter] = useState([]);
  const [newcolumndata, setnewcolumndata] = useState(
    transactionPurchasetablehead,
  );
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState("");
  const [transpurchaselist, setTranspurchaselist] = useState([]);
  const [statement, setStatement] = useState("");
  const [po_sataus, setPo_sataus] = useState([]);
  const [po_priority, setpo_priority] = useState([]);
  const [imageid, setImageid] = useState();
  const [Productmodaldata, setProductmodaldata] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("Pending for Stock");
  const [skip, setSkip] = useState();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [datalodaer, setDatsLodaer] = useState(false);
  const [pdfLoadingIds, setPdfLoadingIds] = useState(new Set());
  const [filterchangestatus, setfilterchangestatus] = useState(2);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" },
    );
  };
  const [showSubtasks, setShowSubtasks] = useState(false);
  const [activeSubtask, setActiveSubtask] = useState("Collapse all");
  const subtaskRef = useRef(null);
  const datePickerRef = useRef(null);
  const statusDateSyncRef = useRef(true);
  const [datelable, setDatelable] = useState("LastMonth");

  const [statusDates, setStatusDates] = useState(() => {
    const lastMonth = buildLastMonthDateRange();
    const today = buildTodayDateRange();
    return {
      outstanding: lastMonth,
      pending: lastMonth,
      approved: lastMonth,
      cancelled: today,
    };
  });

  const statusValueToCountKey = {
    3: "outstanding",
    2: "pending",
    1: "approved",
    0: "cancelled",
  };

  const getStatusCountKey = (statusValue = filterchangestatus) =>
    statusValueToCountKey[statusValue] || "pending";

  const applyStatusDateToUi = (statusKey) => {
    const next = statusDates[statusKey] || buildLastMonthDateRange();
    const nextStart = next.filter?.[0];
    const nextEnd = next.filter?.[1];
    const sameRange = Boolean(
      datefilter[0] &&
      datefilter[1] &&
      nextStart &&
      nextEnd &&
      new Date(datefilter[0]).getTime() === new Date(nextStart).getTime() &&
      new Date(datefilter[1]).getTime() === new Date(nextEnd).getTime(),
    );
    if (sameRange) {
      if (datelable !== next.label) setDatelable(next.label);
      return false;
    }
    setDatefilter([new Date(nextStart), new Date(nextEnd)]);
    setDatelable(next.label);
    return true;
  };

  const updateCurrentStatusDate = (filter, label) => {
    const statusKey = getStatusCountKey();
    setStatusDates((prev) => ({
      ...prev,
      [statusKey]: { filter, label },
    }));
    setDatefilter(filter);
    setDatelable(label);
  };
  // const colorStyles = {
  //   option: (styles, { data }) => {
  //     return {
  //       ...styles,
  //       backgroundColor: data.color
  //     };
  //   }
  // };
  const colorStyles = {
    option: (styles, { data }) => ({
      ...styles,
      backgroundColor: data.color,
      color: "#fff",
      fontSize: "16px",
      padding: "12px 16px",
      fontFamily: "inherit",
      cursor: "pointer",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    control: (base) => ({
      ...base,
      fontSize: "14px",
      fontFamily: "inherit",
      minHeight: "40px",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
      marginTop: "8px",
      padding: "6px 12px",
      position: "relative",
    }),
  };
  const CustomMenu = (props) => (
    <components.Menu {...props}>
      {/* Arrow */}
      <div
        style={{
          position: "absolute",
          top: "-10px",
          left: "calc(100% - 75px)", // position arrow near the left edge of the select box
          width: 0,
          height: 0,
          borderLeft: "12px solid transparent",
          borderRight: "12px solid transparent",
          borderBottom: "16px solid #fff",
          // boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        }}
      />
      {props.children}
    </components.Menu>
  );
  const priorityarray = [
    { label: "low", value: 0, color: "#D9D9D9", class: "low-text" },
    { label: "medium", value: 1, color: "#D2E4FF", class: "medium-text" },
    { label: "high", value: 2, color: "#FFD2D9", class: "high-text" },
  ];
  useEffect(() => {
    callcolumns();
  }, []);

  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_transcation_purchase",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`,
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Gettranscationpurchase(current, "", "");
  };
  const filter_status = [
    {
      label: t("PO Outstanding"),
      labelcount: "outstanding",
      value: 3,
      color: "gray-mid",
    },
    {
      label: t("Pending for Stock"),
      labelcount: "pending",
      value: 2,
      color: "yellow",
    },
    {
      label: t("Approved"),
      labelcount: "approved",
      value: 1,
      color: "main-green",
    },
    {
      label: t("Canceled"),
      labelcount: "cancelled",
      value: 0,
      color: "danger",
    },
  ];
  // Maps the status-filter bar's color names to real CSS colors, so the
  // active top-level tab's underline matches whichever status is selected.
  const STATUS_COLOR_HEX = {
    yellow: "#F9BC44",
    "main-green": "#5CC7C1",
    danger: "#FF5757",
    "gray-mid": "#A4A4A4",
  };
  const activeTabUnderlineColor =
    STATUS_COLOR_HEX[
      filter_status.find((f) => f.value === filterchangestatus)?.color
    ] || "#5CC7C1";
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Gettranscationpurchase(currentPage, limit, filterchangestatus, search);
  };
  const getlimit = (limit) => {
    setLimit(limit);
    Gettranscationpurchase(1, limit);
    setstate({ ...state, currentPage: 1 });
  };

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 },
  ];

  const setSubTable = async (id) => {
    var e = document.querySelector("#table-btn_" + id);
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      let alllist_data = [...transpurchaselist];
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = null;
        });
      setTranspurchaselist(alllist_data);
    } else {
      classList_.add("rotate-90");
      let alllist_data = [...transpurchaselist];
      const postdata = {
        po_order_id: id,
        show_all: false,
        filterchangestatus: filterchangestatus,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/purchase/getPuDetails`,
      );
      var html_ = purchase_product_list(
        prioritydata,
        setImageid,
        setProductmodaldata,
        t,
      );
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = html_;
        });
      setTranspurchaselist(alllist_data);
    }
  };
  const handleOpenPDF = async (id) => {
    if (pdfLoadingIds.has(id)) return;
    setPdfLoadingIds((prev) => new Set(prev).add(id));
    let GetloadingID = loading();
    try {
      const blobData = await _PdfApi(
        { id },
        "api/v1/Inventory/purchase/generatePurchasePdf",
      );
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
    } catch (err) {
      // console.error("Error opening PDF:", err);
      // error(t("Something Went Wrong!!"));
      Updateloading(t, GetloadingID, t("somthing went wrong"), "error");
    } finally {
      setPdfLoadingIds((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };
  const setSubTablePU = async (id) => {
    var e = document.querySelector("#table-btnpu_" + id);
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      let alllist_data = [...transpurchaselist];
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = null;
        });
      setTranspurchaselist(alllist_data);
    } else {
      classList_.add("rotate-90");
      let alllist_data = [...transpurchaselist];
      const postdata = {
        po_order_id: id,
        show_all: false,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/purchase/getPuDetails`,
      );
      var html_ = purchase_product_list(
        prioritydata,
        setImageid,
        setProductmodaldata,
        t,
      );
      alllist_data
        .filter((item) => item.id === id)
        .forEach((result) => {
          result.subTabledata = html_;
        });
      setTranspurchaselist(alllist_data);
    }
  };
  const Changepriority = (index, value, po_order_id) => {
    setStatement(t("Change Priority"));
    setpo_priority([{ index: index, status: value, po_order_id: po_order_id }]);
    var mainarray = [...transpurchaselist];
    mainarray[index]["status"] = {
      ...mainarray[index]["status"],
      priority: value?.value,
    };
    setTranspurchaselist(mainarray);
    document.querySelector("#status_query_select").click();
  };

  const handler_status = async () => {
    if (!po_sataus[0]?.po_order_id) return;
    const GetloadingID = loading();
    try {
      let last_stock_id = "";
      const pudetails = await _Api(
        { po_order_id: po_sataus[0].po_order_id, show_all: false },
        `api/v1/Inventory/purchase/getPuDetails`,
      );
      if (pudetails?.code === 200) {
        const data = pudetails?.data || {};
        const savedRow = Object.values(data?.po_product_data || {}).find(
          (row) => row?.last_stock_id,
        );
        const stockIds = (data?.stock_ids || []).filter(Boolean);
        last_stock_id =
          data?.last_stock_id ||
          savedRow?.last_stock_id ||
          stockIds[stockIds.length - 1] ||
          "";
      }
      const postdata = {
        pu_order_id: po_sataus[0].po_order_id,
        status: po_sataus[0].status?.value,
        last_stock_id: last_stock_id,
      };
      let statusdata = await _Api(
        postdata,
        `api/v1/Inventory/purchase/editPUStatus`,
      );
      if (statusdata?.code === 200) {
        Updateloading(t, GetloadingID, statusdata?.message || "Status Updated!!");
        Gettranscationpurchase();
      } else {
        Updateloading(t, GetloadingID, statusdata?.message || "Something Went Wrong!!", "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, "Something Went Wrong!!", "error");
    }
  };
  const handler_priority = async () => {
    const GetloadingID = loading();
    try {
      const postdata = {
        pu_order_id: po_priority[0].po_order_id,
        status: po_priority[0].status?.value,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/Inventory/purchase/editPriorityStatus`,
      );
      if (prioritydata?.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Priority Updated!!"));
        Gettranscationpurchase();
      } else {
        Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something Went Wrong!!"), "error");
    }
  };

  const select_po_status = (index, value, po_order_id) => {
    setStatement("Change Status");
    setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
    document.querySelector("#status_query_select").click();
  };

  const [excuteTable, setexcuteTable] = useState(false);

  const sortedList = useMemo(() => {
    const accessor = SORT_ACCESSORS[sortConfig.key];
    if (!accessor) return transpurchaselist;
    const sorted = [...transpurchaselist].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null) return 1;
      if (bv === undefined || bv === null) return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [transpurchaselist, sortConfig]);

  const Gettranscationpurchase = useCallback(
    async (current, firstlimit, filters_status, search) => {
      setexcuteTable(false);
      // setfilterchangestatus(filters_status)
      if (filterchangestatus === 3) {
        navigate("/app/inventory/purchaseOrderOutstanding");
      }
      try {
        setDatsLodaer(true);
        setTimeout(async function () {
          const postdata = {
            start_date: datefilter ? datefilter[0] : "",
            end_date: datefilter ? datefilter[1] : "",
            search: search ? search : "",
            skip: skip === 0 ? skip : current ? (current - 1) * limit : 0,
            status:
              filters_status === 0
                ? 0
                : filters_status
                  ? filters_status
                  : filterchangestatus,
            limit: firstlimit ? firstlimit : limit,
          };

          let restranspurchase = await _Api(
            postdata,
            `api/v1/Inventory/purchase/getList`,
          );
          if (restranspurchase?.code === 200) {
            setDatsLodaer(false);
            setexcuteTable(true);
            setstate({
              ...state,
              totalPages: Math.ceil(restranspurchase?.count / postdata.limit),
              currentPage: current ? current : 1,
            });
            setTranspurchaselist(restranspurchase?.data);
            if (!(current && Number(current) > 1)) {
              transactionTotals({
                start_date: datefilter[0],
                end_date: datefilter[1],
                statusDateMap: buildStatusDateMapFromState(statusDates),
                moduleKey: "PU",
              });
            }
            dataFetched.current = false;
          } else {
            setDatsLodaer(false);
          }
        }, 100);
      } catch (err) {
        console.log(err, "err");
      }
    },
    [datefilter, limit, skip, state, navigate, filterchangestatus, statusDates],
  );

  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      Gettranscationpurchase();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    transactionPurchasetablehead.map(async (r, k) => {
      header_values.push(r?.lable);
    });
    if (transpurchaselist.length) {
      transpurchaselist.forEach((result, key) => {
        bodyarray.push([
          result?.createdAt,
          result?.pu_no,
          result?.po_no,
          result?.supplier_name,
          result?.location_name,
          result?.sku,
          result?.total_quantity,
          result?.delivery_date,
          result?.due_days,
          result?.total_amount,
          result.status.pu_status === 0
            ? "Canceled"
            : result.status.pu_status === 1
              ? "Completed"
              : result.status.pu_status === 2
                ? "Pending"
                : result.status.pu_status === 3
                  ? "Approved"
                  : "",
          result.status.priority === 0
            ? "Low"
            : result.status.priority === 1
              ? "Medium"
              : "High",
          result?.note,
          result?.user_actions?.created_by_name,
          result?.user_actions?.updated_by_name,
        ]);
      });
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, {
      origin: "A2",
      skipHeader: true,
    });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: "A1" });
    XLSX.utils.book_append_sheet(wb, ws, "Records");
    const fileContent = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "purchaselist");
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (subtaskRef.current && !subtaskRef.current.contains(event.target)) {
        setShowSubtasks(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const statusKey = getStatusCountKey(filterchangestatus);
    const rangeChanged = applyStatusDateToUi(statusKey);
    if (statusDateSyncRef.current) {
      statusDateSyncRef.current = false;
      return;
    }
    if (!rangeChanged) {
      Gettranscationpurchase(1, limit, filterchangestatus);
    }
    // eslint-disable-next-line
  }, [filterchangestatus, selectedLabel]);

  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === "Today") {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      updateCurrentStatusDate([todayStart, new Date()], "Today");
    } else if (lable === "Yesterday") {
      const yesterdayStart = new Date(MainDate.setDate(MainDate.getDate() - 1));
      yesterdayStart.setHours(0, 0, 0, 0);
      const yesterdayEnd = new Date(yesterdayStart);
      yesterdayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([yesterdayStart, yesterdayEnd], "Yesterday");
    } else if (lable === "7days") {
      const sevendays = new Date(MainDate.setDate(MainDate.getDate() - 7));
      sevendays.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([sevendays, todayEnd], "7days");
    } else if (lable === "30days") {
      const days = new Date(MainDate.setDate(MainDate.getDate() - 30));
      days.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([days, todayEnd], "30days");
    } else if (lable === "ThisMonth") {
      const firstDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 1);
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() + 1,
        0,
      );
      lastDay.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([firstDay, lastDay], "ThisMonth");
    } else if (lable === "LastMonth") {
      const firstDay = new Date(
        MainDate.getFullYear(),
        MainDate.getMonth() - 1,
        1,
      );
      firstDay.setHours(0, 0, 0, 0);
      const lastDay = new Date(MainDate.getFullYear(), MainDate.getMonth(), 0);
      lastDay.setHours(23, 59, 59, 999);
      updateCurrentStatusDate([firstDay, lastDay], "LastMonth");
    }
  };

  const collapseAll = () => {
    document
      .querySelectorAll(".sku-col.col-highlight.rotate-90")
      .forEach((el) => {
        el.classList.remove("rotate-90");
      });
    const updated = transpurchaselist.map((result) => ({
      ...result,
      subTabledata: null,
    }));
    setTranspurchaselist(updated);
  };

  const expandAll = async () => {
    let alllist_data = [...transpurchaselist];
    const ids = alllist_data.map((item) => item.id);
    try {
      const batchResponse = await _Api(
        { pu_order_ids: ids, show_all: false, filterchangestatus },
        `api/v1/Inventory/purchase/getPUDetailsBatch`,
      );
      if (batchResponse?.code === 200) {
        for (let i = 0; i < alllist_data.length; i++) {
          const result = alllist_data[i];
          const rowData = batchResponse.data[result.id];
          if (rowData) {
            const e = document.querySelector("#table-btn_" + result.id);
            if (e) e.classList.add("rotate-90");
            alllist_data[i] = {
              ...alllist_data[i],
              subTabledata: purchase_product_list(
                {
                  code: 200,
                  data: {
                    id: result.id,
                    po_product_data: rowData?.po_product_data,
                  },
                },
                setImageid,
                setProductmodaldata,
                t,
              ),
            };
          }
        }
        setTranspurchaselist([...alllist_data]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  return (
    <React.Fragment>
      <div className="main-body" style={{ paddingTop: "0px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                style={{
                  position: "sticky",
                  top: "128px",
                  zIndex: 5,
                  flexShrink: 0,
                  background: " #f9f9fb",
                  width: "100%",
                  paddingTop: "15px",
                  opacity: 0.9,
                }}
              >
                <h1 className="main-body-heading">{t("Transaction")}</h1>
                <div className="main-body-top-tab-bar">
                  <div
                    className="main-body-top-tab-bar-left-col nav nav-pills"
                    role="tablist"
                  >
                    <Link
                      className={
                        parmissiondatashow?.purchase_order?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase Order")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.PO?.total
                          ? totalcountsnumber?.PO?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className="main-body-top-tab-bar-left-col-a nav-link active"
                      to="/app/inventory/transactionPurchase"
                      style={{
                        "--tab-underline-color": activeTabUnderlineColor,
                      }}
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Purchase")}
                      </span>
                      <span
                        className="num-tab"
                        data-bs-toggle="collapse"
                        data-bs-target="#tPurchase"
                      >
                        {totalcountsnumber?.PU?.total
                          ? totalcountsnumber?.PU?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_stock_Receive
                          ?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/stock_transfer"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Transfer")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.ST?.total
                          ? totalcountsnumber?.ST?.total
                          : "0"}
                      </span>
                    </Link>
                    <Link
                      className={
                        parmissiondatashow?.inventory_transaction_stock_Receive
                          ?.View
                          ? "main-body-top-tab-bar-left-col-a nav-link"
                          : "d-none"
                      }
                      to="/app/inventory/transactionStockReceive"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Receive")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SR ? totalcountsnumber?.SR : "0"}
                      </span>
                    </Link>
                    <Link
                      className="main-body-top-tab-bar-left-col-a nav-link"
                      to="/app/inventory/stockAdjustment"
                    >
                      <span className="main-body-top-tab-bar-left-col-a-text">
                        {t("Stock Adjustment")}
                      </span>
                      <span className="num-tab">
                        {totalcountsnumber?.SA?.total
                          ? totalcountsnumber?.SA?.total
                          : "0"}
                      </span>
                    </Link>
                  </div>
                  <div className="main-body-top-tab-bar-right-col">
                    <Link to="" className="main-body-top-tab-bar-right-col-a">
                      <img
                        src={base_assets + "images/icons/kanban-icon.svg"}
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("KANBAN")}
                      </span>
                    </Link>
                    <Link
                      to="/app/inventory/purchaseOrderOutstanding"
                      className="main-body-top-tab-bar-right-col-a"
                    >
                      <img
                        src={base_assets + "images/icons/outstanding-icon.png"}
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("PO Outstanding")}
                      </span>
                      <span className="main-body-top-tab-bar-right-col-a-num">
                        {totalcountsnumber?.PU?.outstanding
                          ? "(" + totalcountsnumber?.PU?.outstanding + ")"
                          : ""}
                      </span>
                    </Link>
                    <span
                      className={
                        parmissiondatashow?.inventory_transaction_purchase?.Add
                          ? "divider"
                          : "d-none"
                      }
                    />
                    <Link
                      to="/app/inventory/createPurchase"
                      className={
                        parmissiondatashow?.inventory_transaction_purchase?.Add
                          ? "main-body-top-tab-bar-right-col-a"
                          : "d-none"
                      }
                    >
                      <img
                        src={base_assets + "images/icons/plus-circle-white.png"}
                        alt=""
                      />
                      <span className="main-body-top-tab-bar-right-col-a-text">
                        {t("Create")}
                      </span>
                    </Link>
                  </div>
                </div>
                <div id="tPurchase" className="collapse show">
                  <div className="main-body-top-color-bar">
                    {filter_status.map((result, key) => {
                      return (
                        <div
                          className="main-body-top-color-bar-single"
                          onClick={() => {
                            // Gettranscationpurchase("", '', result?.value);
                            setfilterchangestatus(result?.value);
                            setSelectedLabel(result?.label);
                            setSkip(0);
                          }}
                          key={key}
                        >
                          <div
                            className={
                              "main-body-top-color-bar-single-color " +
                              result?.color +
                              "-bg"
                            }
                          />
                          <span
                            className={
                              "main-body-top-color-bar-single-color-status " +
                              result?.color +
                              "-text"
                            }
                          >
                            {result?.label}
                          </span>
                          <span>
                            {totalcountsnumber?.PU?.[`${result?.labelcount}`]
                              ? totalcountsnumber?.PU?.[`${result?.labelcount}`]
                              : "0"}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="main-body-top-status-bar">
                  <Select
                    className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
                    options={selectOptions}
                    value={{ label: limit, value: limit }}
                    onChange={(e) => {
                      setLimit(e.value);
                      getlimit(e.value);
                    }}
                    isSearchable={false}
                  />
                  <div className="main-body-top-status-bar-filter">
                    <input
                      type="text"
                      value={filtername}
                      className="main-body-top-status-bar-filter-input"
                      placeholder={t("PU No/StockID")}
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => setFiltername(e.target.value)}
                    />
                    {filtername ? (
                      <img
                        className="main-body-top-status-bar-filter-clear"
                        src={base_assets + "images/icons/False.png"}
                        onClick={(e) => {
                          setFiltername("");
                          filterbyname("");
                        }}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                    <button
                      onClick={() => filterbyname(filtername)}
                      className="main-body-top-status-bar-filter-search"
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                    </button>
                    <Advancedfiltermodel></Advancedfiltermodel>
                  </div>
                  <div className="main-body-top-status-bar-multi-date-picker">
                    <button className="print-export-dropdown-selected-icon d-none">
                      <img
                        src={base_url_assets + "images/icons/printer-icon.png"}
                        alt=""
                      />
                    </button>
                    <div className="position-relative" ref={subtaskRef}>
                      <div
                        className={`calendarlist-headbar-left-subtasks ${activeSubtask === "Expand all" ? "active" : ""}`}
                        onClick={() => setShowSubtasks(!showSubtasks)}
                        style={{ border: "none", background: "none" }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3Z"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 8V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                          <path
                            d="M5 7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H14"
                            stroke={
                              activeSubtask === "Expand all"
                                ? "#52CBC4"
                                : "#A0A0A0"
                            }
                          />
                        </svg>
                        <span>{t("Subtasks")}</span>
                      </div>
                      {showSubtasks && (
                        <div className="calendarlist-headbar-left-subtaskdropdown">
                          <div className="calendarlist-headbar-left-subtaskdropdown-inner">
                            <div className="calendarlist-headbar-left-subtaskdropdown-inner-title">
                              {t("Show Subtasks")}
                            </div>
                            <div className="calendarlist-headbar-left-subtaskdropdown-inner-list">
                              <div
                                className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
                                onClick={() => {
                                  setActiveSubtask("Collapse all");
                                  setShowSubtasks(false);
                                  collapseAll();
                                }}
                              >
                                <div className="heading">
                                  {t("Collapse all")}
                                  <span className="default">
                                    {t("(default)")}
                                  </span>
                                </div>
                                {activeSubtask === "Collapse all" && (
                                  <div>
                                    <GreenTick />
                                  </div>
                                )}
                              </div>
                              <div
                                className="calendarlist-headbar-left-subtaskdropdown-inner-list-item"
                                onClick={() => {
                                  setActiveSubtask("Expand all");
                                  setShowSubtasks(false);
                                  expandAll();
                                }}
                              >
                                <div>{t("Expand all")}</div>
                                {activeSubtask === "Expand all" && (
                                  <div>
                                    <GreenTick />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                      <button
                        className="dropdown-toggle btn-style align-items-center d-flex"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                            stroke="currentcolor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        {t(datelable)}
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-right-fix"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className={`dropdown-item ${datelable === "Today" ? "active" : ""}`}
                          onClick={() => changeDates("Today")}
                        >
                          {t("Today")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Yesterday" ? "active" : ""}`}
                          onClick={() => changeDates("Yesterday")}
                        >
                          {t("Yesterday")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "7days" ? "active" : ""}`}
                          onClick={() => changeDates("7days")}
                        >
                          {t("Last 7 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "30days" ? "active" : ""}`}
                          onClick={() => changeDates("30days")}
                        >
                          {t("Last 30 days")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "ThisMonth" ? "active" : ""}`}
                          onClick={() => changeDates("ThisMonth")}
                        >
                          {t("This Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "LastMonth" ? "active" : ""}`}
                          onClick={() => changeDates("LastMonth")}
                        >
                          {t("Last Month")}
                        </li>
                        <li
                          className={`dropdown-item ${datelable === "Custom Range" ? "active" : ""}`}
                          onClick={() => datePickerRef.current.setOpen(true)}
                        >
                          {t("Custom Range")}
                        </li>
                      </ul>
                      <DatePicker
                        selectsRange={true}
                        monthsShown={2}
                        startDate={datefilter[0]}
                        endDate={datefilter[1]}
                        onChange={(update) => {
                          const startDate = update[0];
                          const endDate = update[1];
                          setDatelable("Custom Range");
                          if (startDate && endDate) {
                            const modifiedStartDate = new Date(startDate);
                            modifiedStartDate.setHours(0, 0, 0, 0);
                            const modifiedEndDate = new Date(endDate);
                            modifiedEndDate.setHours(23, 59, 59, 999);
                            updateCurrentStatusDate(
                              [modifiedStartDate, modifiedEndDate],
                              "Custom Range",
                            );
                          } else {
                            setDatefilter([startDate, endDate]);
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        ref={datePickerRef}
                        autoComplete="none"
                      />
                    </div>
                    <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            base_url_assets +
                            "images/icons/ellipsis-circular.png"
                          }
                          alt=""
                        />
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li
                          className="dropdown-item"
                          onClick={() => downloadexclsheet()}
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets +
                                "images/icons/export-x-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("export")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#poPuSampleFormatModal"
                        >
                          <div className="dropdown-item-img">
                            {/* Same icon as Create PO → Sample */}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 1.333v9.334M8 10.667L5.333 8M8 10.667L10.667 8M2.667 14h10.666" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                          <span>{t("Sample")}</span>
                        </li>
                        <li
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#columnModal"
                        >
                          <div className="dropdown-item-img">
                            <img
                              src={
                                base_url_assets + "images/icons/column-icon.png"
                              }
                              alt=""
                            />
                          </div>
                          <span>{t("column")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="main-body-main-table-wrap position-relative"
                id="table-scroll"
                style={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <table
                  id="tbl_transactionPurchase_list"
                  className="stripe row-border order-column common-table table-striped main-table w-100"
                >
                  <thead>
                    <tr>
                      {newcolumndata?.map((col, index) => {
                        if (!col?.status) return null;
                        const sortKey = SORT_KEYS[index];
                        const active = sortConfig.key === sortKey;
                        return (
                          <th
                            key={index}
                            className={col.class}
                            onClick={
                              sortKey ? () => handleSort(sortKey) : undefined
                            }
                            style={sortKey ? { cursor: "pointer" } : undefined}
                          >
                            {t(col.lable)}
                            {sortKey ? (
                              <div className="up-down-arrow-btn">
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-forward" +
                                    (active && sortConfig.direction === "desc"
                                      ? ""
                                      : " active")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow.png"
                                  }
                                  alt=""
                                />
                                <img
                                  className={
                                    "up-down-arrow-img up-down-arrow-img-reverse" +
                                    (active && sortConfig.direction === "desc"
                                      ? " active"
                                      : "")
                                  }
                                  src={
                                    base_url_assets +
                                    "images/icons/up-down-arrow-reverse.png"
                                  }
                                  alt=""
                                />
                              </div>
                            ) : null}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {sortedList.length
                        ? sortedList.map((result, key) => {
                            var po_status_class_val = purchase_status(
                              result.status.pu_status,
                            );
                            var priority_class_val = status_priority(
                              result.status.priority,
                            );
                            var valueofpriority = [];
                            if (result.status.priority === 0) {
                              valueofpriority = [
                                { label: t("Low"), value: 0, color: "#D9D9D9" },
                              ];
                            } else if (result.status.priority === 1) {
                              valueofpriority = [
                                {
                                  label: t("Medium"),
                                  value: 1,
                                  color: "#D2E4FF",
                                },
                              ];
                            } else {
                              valueofpriority = [
                                {
                                  label: t("High"),
                                  value: 2,
                                  color: "#FFD2D9",
                                },
                              ];
                            }
                            var colorsArray = [];
                            var valueofstatus = [];
                            if (result.status.pu_status === 1) {
                              valueofstatus = [
                                {
                                  label: t("Approved"),
                                  value: result.status.pu_status,
                                  color: "#0ECB81",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: "Pending",
                                  value: 2,
                                  color: "#F9BC44",
                                },
                              ];
                            } else if (result.status.pu_status === 2) {
                              valueofstatus = [
                                {
                                  label: t("Pending"),
                                  value: result.status.pu_status,
                                  color: "#F9BC44",
                                },
                              ];
                              colorsArray = [
                                {
                                  label: t("Approved"),
                                  value: 1,
                                  color: "#0ECB81",
                                },
                                {
                                  label: t("Canceled"),
                                  value: 0,
                                  color: "#FF5757",
                                },
                              ];
                            } else if (result.status.pu_status === 0) {
                              valueofstatus = [
                                {
                                  label: t("Canceled"),
                                  value: result.status.pu_status,
                                  color: "#FF5757",
                                },
                              ];
                            } else if (result.status.pu_status === 3) {
                              valueofstatus = [
                                {
                                  label: t("Completed"),
                                  value: result.status.pu_status,
                                  color: "#68B8F2",
                                },
                              ];
                            }
                            return (
                              <React.Fragment key={key + "po_product_editList"}>
                                <tr
                                  id={`common-main-table-wrap-${result?.id}`}
                                  key={result?.id}
                                >
                                  {newcolumndata[0]?.status && (
                                    <td className="fixed-side">
                                      {result?.createdAt
                                        ? result?.createdAt
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[1]?.status && (
                                    <td className="po-no">
                                      <Link
                                        to={
                                          result?.pu_no
                                            ? "/app/inventory/editPurchase"
                                            : ""
                                        }
                                        state={{
                                          product_id: result.id,
                                          location_id: result?.location_id,
                                          supplier_id: result?.supplier_id,
                                          warehouse_id: result?.warehouse_id,
                                          pu_no: result?.pu_no,
                                          Voucher_id: result?.voucher_id,
                                          transactiondate:
                                            result?.transaction_date_unformated,
                                          deliverydate:
                                            result?.delivery_date_unformated,
                                          purchasestatus:
                                            result.status.pu_status,
                                          printparmission:
                                            parmissiondatashow
                                              ?.inventory_transaction_purchase
                                              ?.Print,
                                        }}
                                      >
                                        {result?.pu_no ? result?.pu_no : "-"}
                                      </Link>
                                    </td>
                                  )}
                                  {newcolumndata[2]?.status &&
                                    (result?.po_order_count > 1 ? (
                                      <td
                                        className="sku-col"
                                        onClick={() => setSubTablePU(result.id)}
                                        id={"table-btnpu_" + result.id}
                                      >
                                        <img
                                          className="sku-col-arrow"
                                          src={
                                            base_assets +
                                            "/images/icons/right_green_button.png"
                                          }
                                          alt=""
                                        />
                                        <span>{result?.po_order_count}</span>
                                      </td>
                                    ) : (
                                      <td className="po-no">
                                        <Link
                                          to={
                                            result?.po_no
                                              ? "/app/inventory/edit-po-pos"
                                              : ""
                                          }
                                          state={{
                                            posid: result?.po_order_id,
                                            po_status: 1,
                                            transactiondate:
                                              result?.transaction_date_unformated,
                                            deliverydate:
                                              result?.delivery_date_unformated,
                                          }}
                                        >
                                          {result?.po_no ? result?.po_no : "-"}
                                        </Link>
                                      </td>
                                    ))}
                                  {newcolumndata[3]?.status && (
                                    <td>
                                      <div className="tooltip-area-up">
                                        <div className="truncate-text-subtable">
                                          {result?.supplier_name
                                            ? result?.supplier_name
                                            : "-"}
                                        </div>
                                        {result?.supplier_name && <span className="tooltip-area-up-text text-white">{result?.supplier_name}</span>}
                                      </div>
                                    </td>
                                  )}
                                  {newcolumndata[4]?.status && (
                                    <td>
                                      {result?.location_name
                                        ? result?.location_name
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[5]?.status && (
                                    <td
                                      className="sku-col col-highlight"
                                      onClick={() => setSubTable(result.id)}
                                      id={"table-btn_" + result.id}
                                    >
                                      <div className="td-icons-wrap">
                                        <div>
                                          <img
                                            className="sku-col-arrow"
                                            src={
                                              base_assets +
                                              "/images/icons/right_green_button.png"
                                            }
                                            alt=""
                                          />
                                          <span>
                                            {result?.sku ? result?.sku : "-"}
                                          </span>
                                        </div>
                                        {result.allocatable ? (
                                          <div className="td-icons-wrap-link">
                                            <img
                                              className="img "
                                              src={
                                                base_assets +
                                                "images/icons/link-icon.svg"
                                              }
                                              alt=""
                                            />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        <div className="tooltip-area-up">
                                          {result?.pos_Qty !== 0 ? (
                                            <div className="td-icons-wrap-user">
                                              <img
                                                className="img"
                                                src={
                                                  base_assets +
                                                  "images/icons/gray-user.png"
                                                }
                                                alt=""
                                              />{" "}
                                              <span>{result?.pos_Qty}</span>
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <span className="tooltip-area-up-text">
                                            {result?.pos?.customer_name}
                                            {result?.pos?.customer_name ? (
                                              <br />
                                            ) : (
                                              ""
                                            )}
                                            {result?.pos?.ref}
                                            <br />
                                            {formatDate(
                                              result?.pos?.delivery_date,
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                  {newcolumndata[6]?.status && (
                                    <td className="col-highlight">
                                      {result?.total_quantity
                                        ? result?.total_quantity
                                        : "0"}
                                    </td>
                                  )}
                                  {newcolumndata[7]?.status && (
                                    <td className="col-highlight">
                                      {result?.delivery_date
                                        ? result?.delivery_date
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[8]?.status && (
                                    <td className="col-highlight">
                                      {result?.due_days}
                                    </td>
                                  )}
                                  {newcolumndata[9]?.status && (
                                    <td className="col-highlight">
                                      {result?.total_amount
                                        ? toFormatPrice(result?.total_amount, {
                                            addSymbol: true,
                                          })
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[10]?.status && (
                                    <td className="col-highlight">
                                      <div
                                        className={
                                          "dropdown status-dropdown status-dropdown-select " +
                                          po_status_class_val
                                        }
                                      >
                                        <Select
                                          options={
                                            parmissiondatashow
                                              ?.inventory_transaction_purchase
                                              ?.Status
                                              ? colorsArray
                                              : []
                                          }
                                          value={valueofstatus}
                                          isDisabled={
                                            result.status.pu_status === 0
                                              ? true
                                              : false
                                          }
                                          onChange={(event) =>
                                            select_po_status(
                                              key,
                                              event,
                                              result.id,
                                            )
                                          }
                                          classNamePrefix="status-dropdown-select"
                                          styles={colorStyles}
                                          getOptionLabel={(e) => (
                                            <div className="">{e.label}</div>
                                          )}
                                          isSearchable={false}
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          components={{ Menu: CustomMenu }}
                                        />
                                      </div>
                                    </td>
                                  )}
                                  {newcolumndata[11]?.status && (
                                    <td className="col-highlight">
                                      <div
                                        className={
                                          "dropdown status-dropdown status-dropdown-select " +
                                          priority_class_val
                                        }
                                      >
                                        <Select
                                          options={priorityarray}
                                          value={valueofpriority}
                                          onChange={(event) =>
                                            Changepriority(
                                              key,
                                              event,
                                              result.id,
                                            )
                                          }
                                          classNamePrefix="status-dropdown-select"
                                          styles={colorStyles}
                                          getOptionLabel={(e) => (
                                            <div className={e.class}>
                                              {e.label}
                                            </div>
                                          )}
                                          isSearchable={false}
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          components={{ Menu: CustomMenu }}
                                        />
                                      </div>
                                    </td>
                                  )}
                                  {newcolumndata[12]?.status && (
                                    <td className="col-highlight">
                                      {result?.note ? result?.note : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[13]?.status && (
                                    <td className="col-highlight">
                                      {result?.user_actions?.created_by_name
                                        ? result?.user_actions?.created_by_name
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[14]?.status && (
                                    <td className="col-highlight">
                                      {result?.user_actions?.updated_by_name
                                        ? result?.user_actions?.updated_by_name
                                        : "-"}
                                    </td>
                                  )}
                                  {newcolumndata[15]?.status && (
                                    <td>
                                      <div
                                        onClick={() =>
                                          !pdfLoadingIds.has(result?.id) &&
                                          handleOpenPDF(result?.id)
                                        }
                                        style={{
                                          opacity: pdfLoadingIds.has(result?.id)
                                            ? 0.5
                                            : 1,
                                          pointerEvents: pdfLoadingIds.has(
                                            result?.id,
                                          )
                                            ? "none"
                                            : "auto",
                                        }}
                                      >
                                        <img
                                          className="pdf-image cursor-pointer"
                                          src={
                                            base_assets +
                                            "images/icons/pdf-icon.png"
                                          }
                                          alt="PDF"
                                        />
                                      </div>
                                    </td>
                                  )}
                                </tr>
                                {excuteTable ? (
                                  <>
                                    {typeof result.subTabledata == "undefined"
                                      ? (result.subTabledata = "")
                                      : result.subTabledata}
                                  </>
                                ) : null}
                              </React.Fragment>
                            );
                          })
                        : ""}
                    </>
                  </tbody>
                  <tfoot>
                    <tr>
                      {newcolumndata[0]?.status && <td />}
                      {newcolumndata[1]?.status && <td />}
                      {newcolumndata[2]?.status && <td />}
                      {newcolumndata[3]?.status && <td />}
                      {newcolumndata[4]?.status && <td />}
                      {newcolumndata[5]?.status && <td />}
                      {newcolumndata[6]?.status && (
                        <td>
                          {transpurchaselist
                            ? transpurchaselist?.reduce(
                                (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.total_quantity)),
                                0,
                              )
                            : ""}
                        </td>
                      )}
                      {newcolumndata[7]?.status && <td />}
                      {newcolumndata[8]?.status && <td />}
                      {newcolumndata[9]?.status && (
                        <td>
                          {toFormatPrice(
                            transpurchaselist
                              ? transpurchaselist?.reduce(
                                  (interation, val) =>
                                    (interation =
                                      interation +
                                      toUnformatPrice(val?.total_amount)),
                                  0,
                                )
                              : "",
                            { addSymbol: true },
                          )}
                        </td>
                      )}
                      {newcolumndata[10]?.status && <td />}
                      {newcolumndata[11]?.status && <td />}
                      {newcolumndata[12]?.status && <td />}
                      {newcolumndata[13]?.status && <td />}
                      {newcolumndata[14]?.status && <td />}
                      {newcolumndata[15]?.status && <td />}
                    </tr>
                  </tfoot>
                </table>
                {datalodaer && <TableLoader />}
              </div>
            </div>
            {transpurchaselist.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <SocialModal />
        <ProductModal
          data_product={Productmodaldata}
          setOneproduct={setProductmodaldata}
          editproduct_submit={""}
        />
        <ProductImageSliderModal main_id={imageid}></ProductImageSliderModal>
        <PoPuSampleFormatModal sampleType="PU" />
        <TableColumnModal
          tablehead={transactionPurchasetablehead}
          tblName={"tbl_transcation_purchase"}
          calldatatable={Gettranscationpurchase}
          setnewcolumndata={setnewcolumndata}
        ></TableColumnModal>
        <ConfirmationModel
          statement={statement}
          handler_submit={
            statement === "Change Status" ? handler_status : handler_priority
          }
          handler_dismiss={Gettranscationpurchase}
        ></ConfirmationModel>
        <button
          className="d-none"
          data-bs-toggle="modal"
          data-bs-target="#createPurchaseModal"
          id="status_query_select"
        ></button>
      </div>
    </React.Fragment>
  );
};

export default TransactionPurchase;
